/** Browser-facing URL boundary. Never serialize credentials or executable/document schemes. */
export function safeDisplayUrl(value: unknown, kind: 'link' | 'media'): string | undefined {
  if (typeof value !== 'string') return undefined;
  const text = value.trim();
  if (!text || /[\u0000-\u001f\u007f\\]/.test(text)) return undefined;
  // Scheme-relative parsing must not change when the consumer page uses another protocol.
  if (/^https?:/i.test(text) && !/^https?:\/\//i.test(text)) return undefined;
  let url: URL;
  try { url = new URL(text, 'https://monkeys.invalid/'); } catch { return undefined; }
  if (url.username || url.password) return undefined;
  if (url.protocol === 'http:' || url.protocol === 'https:') return text;
  if (kind === 'link' && (url.protocol === 'mailto:' || url.protocol === 'tel:')) return text;
  if (url.protocol === 'blob:') {
    if (url.pathname.startsWith('null/')) return text;
    try {
      const origin = new URL(url.pathname);
      if (['https:', 'http:'].includes(origin.protocol) && !origin.username && !origin.password) return text;
    } catch { /* Malformed blob URL. */ }
  }
  return undefined;
}

/** Keep safe responsive images; reject the entire list if any candidate is unsafe or malformed. */
export function safeDisplaySrcSet(value: unknown): string | undefined {
  if (typeof value !== 'string' || !value.trim()) return undefined;
  const candidates = value.split(',');
  for (const candidate of candidates) {
    const parts = candidate.trim().split(/\s+/);
    if (!safeDisplayUrl(parts[0], 'media') || parts.length > 2 ||
        (parts.length === 2 && !/^(?:[1-9]\d*w|(?:\d+(?:\.\d+)?|\.\d+)x)$/.test(parts[1]!))) return undefined;
  }
  return value;
}
